import { mainAPI, handleApiError } from "../api";
import {
  FileUploadRequest,
  FileDeleteRequest,
  FileUploadResponse,
} from "../types/api/file";

const path = `/media/${process.env.REACT_APP_API_VERSION}`;

export function uploadFile(data: FileUploadRequest) {
  const formData = new FormData();
  formData.append("file", data.file);

  return mainAPI
    .post<FileUploadResponse>(`${path}/uploads`, formData, {
      metadata: { addCountry: false },
      headers: {
        "Content-Type": "multipart/form-data",
      },
      signal: data.abortController?.signal,
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total && data.onProgress) {
          const progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          data.onProgress(progress);
        }
      },
    })
    .then(
      (res) => {
        return Promise.resolve(res.data as FileUploadResponse);
      },
      (error) => handleApiError(error)
    );
}

// Файл - Удалить
export function deleteFile(data: FileDeleteRequest) {
  return mainAPI.delete(`${path}/uploads`, { data }).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => handleApiError(error)
  );
}
